import { API_ENDPOINTS } from '../../config/api.js';
import { makeApiRequest } from '../apiClient.js';

export const userService = {
  create: async (formData) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.CREATE_USER,
        method: 'POST',
        data: formData,
        contentType: 'form',
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Create user error:', error);
      throw error;
    }
  },
  update: async (formData) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.UPDATE_USER,
        method: 'POST',
        data: formData,
        contentType: 'form',
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Update user error:', error);
      throw error;
    }
  }, 
  getAllUsers: async (companyId = '0') => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_USERS,
        method: 'POST',
        data: { companyId },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get all users error:', error);
      throw error;
    }
  },
  getById: async (userId) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_BY_ID_USER,
        method: 'POST',
        data: { Id: userId },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get user by ID error:', error);
      throw error;
    }
  },
  delete: async (userId) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.DELETE_USER,
        method: 'POST',
        data: { Id: userId },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Delete user error:', error);
      throw error;
    }
  },
};
